import { Task } from '../pages/plan/kanban/types.ts';
import { getAuth } from 'firebase/auth';
import WedifyApiRequest from './wedify_api_request.js';

export const saveTask = async (body: Task) => {
  const auth = getAuth();
    const currentUser = auth.currentUser;
    if (!currentUser) {
      console.log("User needs to log in before planning");
      return;
    }
    const wedifyApiRequest = new WedifyApiRequest();

    try {
      const response = await wedifyApiRequest.makeRequest(`${process.env.REACT_APP_API_BASE_URL}/api/tasks`, "POST", JSON.stringify(body) as any);
      if (response && response.ok) {
        return await response.json()
      } else {
        console.log("Saving task failed");
      }
    } catch (error) {
      console.error('Error sending message to Discord:', error);
      throw error;
    }
  };

  
export const getTasks = async () => {
  const auth = getAuth();
  const currentUser = auth.currentUser;
  if (!currentUser) {
    console.log("User needs to log in to fetch tasks");
    return;
  }

  try {
    const wedifyApiRequest = new WedifyApiRequest();

    const response = await wedifyApiRequest.makeRequest(`${process.env.REACT_APP_API_BASE_URL}/api/tasks/user`, "GET")
    if (response && response.ok) {
      return await response.json()
    } else {
      console.log("Fetching tasks failed");
    }
  } catch (error) {
    console.error('Error fetching tasks:', error);
    throw error;
  }
};

export const updateTask = async (id: number, updates: Partial<Task>) => {  
  const wedifyApiRequest = new WedifyApiRequest();
  const response = await wedifyApiRequest.makeRequest(`${process.env.REACT_APP_API_BASE_URL}/api/tasks/${id}`, "PUT", JSON.stringify(updates) as any);
  
  if (response && response.ok) {
    return await response.json()
  } else {
    console.log("Updating task failed");
  }
};

export const deleteTask = async (id: number) => {
  const auth = getAuth();
  const currentUser = auth.currentUser;
  if (!currentUser) {
    console.log("User needs to log in to delete tasks");
    return;
  }

  try {
    const wedifyApiRequest = new WedifyApiRequest();
    await wedifyApiRequest.makeRequest(`${process.env.REACT_APP_API_BASE_URL}/api/tasks/${id}`, "DELETE")
    console.log(`Task with ID ${id} deleted successfully.`);
  } catch (error) {
    console.error('Error deleting task:', error);
    throw error; // Rethrow the error for further handling if needed
  }
};